import { AlertTriangle, Home, ArrowLeft, Bug } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ErrorFallback = ({ error }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md w-full text-center border border-gray-200">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <AlertTriangle className="text-red-500" size={40} />
        </div>

        {/* Title */}
        <h1 className="text-xl font-semibold text-gray-900">
          We’re sorry — something went wrong
        </h1>

        {/* Subtitle */}
        <p className="text-sm text-gray-600 mt-2">
          The page encountered an unexpected error. Please try one of the
          options below.
        </p>

        {/* Error details (collapsed by default) */}
        {error && (
          <details className="mt-4 text-left">
            <summary className="cursor-pointer text-xs text-gray-500 hover:text-gray-700">
              Technical details
            </summary>
            <div className="mt-2 bg-gray-50 border rounded-md p-3 text-xs text-gray-600 max-h-28 overflow-auto">
              {error.message}
            </div>
          </details>
        )}

        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={() => (window.location.href = "/")}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white rounded-md transition"
          >
            <Home size={16} />
            Return to Home
          </button>

          <button
            onClick={() => window.history.back()}
            className="flex items-center justify-center gap-2 px-4 py-2 border rounded-md"
          >
            <ArrowLeft size={16} /> Go Back
          </button>

          <button
            onClick={() =>
              navigate("/Report-Issue/E63CBF68-2F41-45C3-BACE-D3192D16DD99")
            }
            className="flex items-center justify-center gap-2 px-4 py-2 border border-red-300 text-red-600 rounded-md hover:bg-red-50 transition"
          >
            <Bug size={16} />
            Report an Issue
          </button>
        </div>

        {/* Footer */}
        <p className="text-[11px] text-gray-400 mt-6">
          Error reference: UI-500 • {new Date().toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default ErrorFallback;
